import { createContext, useContext } from "react";

export interface DeviceInfo {
  isIOS: boolean;
}

export const DeviceInfoContext = createContext<DeviceInfo>({ isIOS: false });

export function useDeviceInfo(): DeviceInfo {
  return useContext(DeviceInfoContext);
}

export function iOS(): boolean {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}
